import { useEffect, useRef, useState } from "react";
import PdpService, {errorMessage} from "../../services/PdpService";
import {usePdpPermissions} from "../../hooks/usePdpPermissions";
export default function PdpDocumentControl({driverId,readOnly=false}:{driverId:number;readOnly?:boolean}) {
  const {canManagePdp}=usePdpPermissions();
  const [present,setPresent]=useState(false);const [error,setError]=useState("");const [busy,setBusy]=useState(false);
  const [loading,setLoading]=useState(true);const input=useRef<HTMLInputElement>(null);
  useEffect(()=>{const c=new AbortController();setLoading(true);setPresent(false);setError("");
    PdpService.documentInfo(driverId,c.signal).then(info=>{if(!c.signal.aborted)setPresent(info.present);})
      .catch(e=>{if(!c.signal.aborted)setError(errorMessage(e));}).finally(()=>{if(!c.signal.aborted)setLoading(false);});
    return ()=>c.abort();},[driverId]);
  async function upload(file?:File){
    if(!file)return;
    if(file.size===0 || file.size>5*1024*1024 || !file.name.toLowerCase().endsWith(".pdf")){setError("Select a PDF file up to 5 MB.");return;}
    setBusy(true);setError("");
    try{await PdpService.uploadDocument(driverId,file);setPresent(true);if(input.current)input.current.value="";}
    catch(e){setError(errorMessage(e));}finally{setBusy(false);}
  }
  async function download(){setBusy(true);setError("");try{await PdpService.downloadDocument(driverId);}catch(e){setError(errorMessage(e));}finally{setBusy(false);}}
  return <div className="form-group" style={{marginTop:12}}>
    <h4>PDP PDF document</h4>
    <p>{loading?"Checking document...":present?"A PDP PDF is attached.":"No PDP PDF uploaded."}</p>
    {present && <button type="button" className="secondary_button" disabled={busy || loading} onClick={download}>Download PDP PDF</button>}
    {!readOnly && canManagePdp && <label> {present?"Replace PDF":"Upload PDF"}
      <input ref={input} aria-label="Upload PDP PDF" type="file" accept="application/pdf,.pdf" disabled={busy || loading} onChange={e=>upload(e.target.files?.[0])}/>
      <span className="form-help">PDF only, up to 5 MB. Upload is saved separately from driver details.</span>
    </label>}
    {busy && <p role="status">Saving or downloading document...</p>}{error && <p role="alert">{error}</p>}
  </div>;
}
